import SpotifyPlayer, { Spotify } from './SpotifyPlayer';

class Music {
    namespace: HTMLElement | null;
    spotify!: Spotify;
    player!: Spotify.Player;
    loginButton!: HTMLElement | null;
    playerToggle!: HTMLElement | null;
    playerContainer!: HTMLElement | null;
    searchInput!: HTMLElement | null;
    discography!: any;
    filteredDiscography!: any;

    constructor() {
        this.namespace = document.getElementById('page-music');  
        if (!this.namespace) return;
        this.initPage();
    }

    initPage() {
        this.discography = []
        this.filteredDiscography = [];

        this.initSpotifyPlayer();

        this.searchInput = document.querySelector('.search-input');
        this.setupFilterButtons();
        this.setupSearchInput();

        this.loginButton = document.querySelector('.spotify-login');
        this.loginButton?.addEventListener('click', () => {
            const width = 500;
            const height = 700;
            const left = (window.screen.width / 2) - (width / 2);
            const top = (window.screen.height / 2) - (height / 2);
            window.open(
                `https://accounts.spotify.com/en-GB/login?continue=${window.location.href}`,
                'Spotify Login',
                `width=${width},height=${height},left=${left},top=${top}`
            );
        });

        this.fetchDiscog();
    }

    setupFilterButtons() {
        const filterButtons = document.querySelectorAll('.album-filters .filter-button');
        filterButtons.forEach(button => {
            button.addEventListener('click', () => {
                // Remove active class from all buttons
                filterButtons.forEach(btn => btn.classList.remove('active'));
                // Add active class to clicked button
                button.classList.add('active');
                
                // Filter based on button text
                const filterType = button.textContent?.toLowerCase();

                this.filterByType(filterType);
            });
        });
    }

    setupSearchInput() {
        this.searchInput?.addEventListener('input', (e) => {
            const target = e.target as HTMLInputElement;
            const searchTerm = target.value.toLowerCase();
            
            this.filteredDiscography = this.discography.items.filter((item: any) => {
                return item.name.toLowerCase().includes(searchTerm);
            });

            this.sortDiscography();
            this.renderDiscography();
        });
    }

    filterByType(type: string | undefined) {
        if (!type || type === 'all') {
            this.filteredDiscography = [...this.discography.items];
        } else {
            this.filteredDiscography = this.discography.items.filter((item: any) => {
                const albumType = item.album.album_type.toLowerCase();
                return albumType === type.slice(0, -1);
            });
        }
        
        this.sortDiscography();
        this.renderDiscography();
    }

    sortDiscography() {
        return this.filteredDiscography;
        // this.filteredDiscography.sort((a: { release_date: string }, b: { release_date: string }) => {
        //     return new Date(b.release_date).getTime() - new Date(a.release_date).getTime();
        // });
    }

    renderDiscography() {
        const discographyContainer = document.querySelector('.albums');

        if (!discographyContainer) return;

        while (discographyContainer.firstChild) {
            discographyContainer.removeChild(discographyContainer.firstChild);
        }

        this.filteredDiscography.forEach((item: any) => {
            const release = document.createElement('div');
            release.classList.add('release');

            const image = document.createElement('img');
            image.src = item.album.images[0].url;
            image.alt = item.name;
            image.classList.add('track-image');
            image.setAttribute('data-spotify-id', item.uri);

            image.addEventListener('click', () => {
                window.spotifyController.loadUri(item.uri);
                window.spotifyController.play();
            });

            const releaseInfo = document.createElement('div');

            const releaseDate = document.createElement('h3');
            releaseDate.innerHTML = `<span>//</span>${this.formatDate(item.album.release_date)}`;

            const releaseTitle = document.createElement('h2');
            releaseTitle.textContent = item.name;

            const artists = document.createElement('h4');
            artists.textContent = item.artists.map((artist: any) => artist.name).join(', ');

            releaseInfo.appendChild(releaseDate);
            releaseInfo.appendChild(releaseTitle);
            releaseInfo.appendChild(artists);

            release.appendChild(image);
            release.appendChild(releaseInfo);

            discographyContainer.appendChild(release);
        });
    }

    formatDate(dateString: string): string {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    }

    async fetchDiscog(): Promise<void> {
        this.discography = await this.spotify.fetchDiscography();
        console.log(this.discography);
    }
  
    async initSpotifyPlayer(): Promise<void> {
        this.spotify = new SpotifyPlayer({ name: 'Perfecto Records Player' });
        this.spotify.checkForAccessToken();
    }
}

interface SpotifyEmbedController {
    loadUri: (uri: string) => void;
    play: () => void;
}

interface SpotifyIframeApi {
    createController: (
        element: HTMLElement | null,
        options: { uri: string },
        callback: (EmbedController: SpotifyEmbedController) => void
    ) => void;
}

declare global {
    interface Window {
        onSpotifyIframeApiReady: (IFrameAPI: SpotifyIframeApi) => void;
    }
}

export default Music;